import { MatchClientModel } from '@sport1/types/sportData'
import dayjs from 'dayjs'

export const getSportsMatchData = (match: MatchClientModel): string =>
    `${match.homeTeam?.name} vs. ${match.awayTeam?.name} | ${dayjs(match.scheduledStartTime).format(
        'DD.MM.YYYY'
    )}`
